import {DI, ILogic, inject, LAYERS, ReelConstants, ReelsView, ReelsViewEvents, SoundManager} from '@gongxigames/framework/slot';
import {Layer} from '@pixi/layers';
import {GameReelView, GameReelViewData} from 'src/gameReels/GameReelView';
import {Reel} from 'com/gongxigames/math/core/game/Reel';
import {WolfHaven} from 'com/gongxigames/math/wolfhaven/engine/WolfHaven';
import {GameLogic} from 'src/server/GameLogic';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';

export class GameReelsView extends ReelsView {
    @inject(DI.Logic)
    protected _logic!: ILogic;
    @inject(DI.SoundManager)
    protected _soundManager!: SoundManager;
    protected _reels: GameReelView[] = [];
    protected _dimensions!: number[];

    public createCachedBlurredSymbols(): void {
        // const {blur} = this._gameConfig.reelsConfig;
        //
        // if (!blur) {
        //     return;
        // }
        //
        // const symbolsSprite: Sprite = this._objectBuilder.buildSprite(ObjectBuilder.resources.game_sprite.symbols);
        // const {width, height} = this._reelConstants.SYMBOL;
        // const region = new Rectangle(0, - (height * 0.5), width, height * 2);
        // const cachedSymbols = {};
        // const symbolFrames = [1, 2, 3];
        //
        // this._displayObjectUtils.addBlurFilter(symbolsSprite, blur);
        //
        // symbolsSprite.children.forEach(child => child.visible = false);
        // symbolsSprite.children.forEach((symbol , index) => {
        //     symbol.visible = true;
        //
        //     symbolFrames.forEach( frame => {
        //         (symbol as MovieClip).gotoAndStop(frame);
        //
        //         cachedSymbols[`${index}_${frame}`] = {
        //             texture: this._displayObjectUtils.generateTexture(symbolsSprite, region),
        //             position: {x:  width / 2, y: height / 2}
        //         };
        //     });
        //
        //     symbol.visible = false;
        // });
        //
        // this._displayObjectUtils.addCachedDisplayObjects(cachedSymbols);
    }

    public showAllSymbols(): void {
        for (let reelIndex = 0; reelIndex < this._reels.length; reelIndex++) {
            const reel = this._reels[reelIndex];

            for (let row = 0; row < this.dimensions[reelIndex]; row++) {
                reel.showSymbolAt(row);
            }
        }
    }

    public hideAllSymbols(): void {
        for (let reelIndex = 0; reelIndex < this._reels.length; reelIndex++) {
            const reel = this._reels[reelIndex];

            for (let row = 0; row < this.dimensions[reelIndex]; row++) {
                reel.hideSymbolAt(row);
            }
        }
    }

    public setNextStrip(reelSet: Reel[]): void {
        for (let reelIndex = 0; reelIndex < this._reels.length; reelIndex++) {
            const reel = this._reels[reelIndex];

            reel.setNextStrip(reelSet[reelIndex].getSymbols());
        }
    }

    public setDimensions(dimensions: number[]): void {
        this.dimensions = dimensions;
        for (let i = 0; i < dimensions.length; i++) {
            const reel = this._reels[i];

            reel.dimension = dimensions[i];
        }
    }

    public updateReelsSymbols(): void {
        this._reels.forEach(reel => {
            reel.resetReelSymbols();
        });
        this.reorderAllOversizeds();
    }

    protected createReel(reelData: GameReelViewData): GameReelView {
        return new GameReelView(reelData);
    }

    protected createReelSet(reels: Reel[], reelsPosition: number[]): void {
        this._symbolsPool.freeAll();
        this.setupReelsLayers();
        this.iterateReels(reels.length, (reelIndex) => {
            const reelData = this.getReelData(reelIndex);

            if (reelsPosition && reelsPosition[reelIndex]) {
                reelData.startPosition = reelsPosition[reelIndex];
            }
            const reel = this.createReel(reelData);

            reel.strip = reels[reelIndex].getSymbols();
            reel.init(this.objectBuilder, this.spineUtils);
            reel.onReelStopping = this.onReelStopping.bind(this);
            reel.onReelStopped = this.onReelStopped.bind(this);
            reel.onReelAnimationFinished = this.onReelAnimationFinished.bind(this);
            reel.onScatterHitAnimationCallback = this.onScatterHitAnimation.bind(this, reelIndex);
            reel.onBounceStoppingStartedCallback = this.onBounceStoppingStarted.bind(this, reelIndex);
            this.updateManager.add(reel);
            reel.start();
            this._reels[reelIndex] = reel;
        });
        this.setupReelSetMaskForStatic();
        this.setReelsBackground();
        this.forceUpdateOrientation();
        this.reorderAllOversizeds();
    }

    protected onReelStopping(reelNr: number, distanceBeforeStop: number): void {
        const isLastReel = reelNr === ReelConstants.REELS_AMOUNT - 1;

        this.playReelRelatedSound(reelNr);

        if (isLastReel) {
            this._animationToBeMaskedContainer.removeChildren();
            this.isQuickStop && this.playLastReelStopSound();
        }
        this.emit(ReelsViewEvents.REEL_STOPPING_CALLBACK, reelNr, distanceBeforeStop);
    }

    protected onReelStopped(reelNr: number): void {
        if (reelNr === 0) {
            if (!this._reels[this._reels.length - 1].isStopped) {
                this.setupReelSetMaskForFirstReelStopped();
            } else {
                this.setupReelSetMaskForStatic();
            }
        }
        this.reOrder();
        this.putOversizedsOnSpecialLayer(reelNr);
        this.emit(ReelsViewEvents.REEL_STOPPED, reelNr);
        const allReelsStopped = this._reels.every((reel) => {
            return reel.isStopped;
        });

        if (allReelsStopped) {
            this.onLastReelStopped();
        }
        this.hideSymbolTails(reelNr);
    }

    protected hideSymbolTails(reelNr: number): void {
        this._reels[reelNr].hideTail(-1);
        this._reels[reelNr].hideTail(this.dimensions[reelNr]);
    }

    protected getReelData(reelIndex: number): GameReelViewData {
        const reelData = super.getReelData(reelIndex) as GameReelViewData;

        reelData.dimension = this._dimensions[reelIndex];

        return reelData;
    }

    protected onLastReelStopped(): void {
        this.setupReelSetMaskForStatic();
        this.emit(ReelsViewEvents.ALL_REELS_STOPPED);
        this._scatterHitOnReel = -1;
        this.scattersNumber = 0;
    }

    protected playReelRelatedSound(reelNr: number): void {
        const lastReel = ReelConstants.REELS_AMOUNT - 1;
        const logic = this._logic as GameLogic;
        const lastReelSymbols = logic.spinData.symbolIds[lastReel];
        const isRandomWildFeature = logic.isRandomWildFeature();
        const isRubySymbolExist = lastReelSymbols.indexOf(WolfHaven.Ruby) !== -1 && reelNr === lastReel;

        if (isRandomWildFeature && reelNr === ReelConstants.REELS_AMOUNT - 1) {
            this.soundPlayer.play('activatorhit');
        } else if (this._scatterHitOnReel !== reelNr && !this._isQuickStop && !isRubySymbolExist) {
            this.soundPlayer.play('reelstop' + (reelNr + 1));
        } else if (this._scatterHitOnReel !== reelNr && isRubySymbolExist) {
            this.soundPlayer.play('rubySymbolStop');
        }
    }

    protected playLastReelStopSound(): void {
        if (this._isQuickStop) {
            const lastReel = ReelConstants.REELS_AMOUNT - 1;
            const logic = this._logic as GameLogic;
            const lastReelSymbols = logic.spinData.symbolIds[lastReel];
            const isRubySymbolExist = lastReelSymbols.indexOf(WolfHaven.Ruby) !== -1;
            const isRandomWildFeature = logic.isRandomWildFeature();
            const isInFreeSpins = this._logic.spinData.action === Action.FREESPIN;

            if (this.scattersNumber >= 3) {
                const sound = this.soundManager.getSound('quickstop3ormorescatter');

                if (sound) {
                    sound.volume = isInFreeSpins ? 3 : 1;
                    sound.play();
                }
            } else if (isRandomWildFeature) {
                this.soundPlayer.play('activatorhit');
            } else if (this.scattersNumber === 2) {
                const sound = this.soundManager.getSound('scatterhit2');

                if (sound) {
                    sound.volume = isInFreeSpins ? 3 : 1;
                    sound.play();
                }
            } else if (this.scattersNumber) {
                const sound = this.soundManager.getSound('scatterhit1');

                if (sound) {
                    sound.volume = isInFreeSpins ? 3 : 1;
                    sound.play();
                }
            } else if (isRubySymbolExist) {
                this.soundPlayer.play('rubySymbolStop');
            } else {
                this.soundPlayer.play(`reelstop${this.reelConstants.REELS_AMOUNT}`);
            }
        }
    }

    public fadeSymbol(reelIndex: number, rowIndex: number): void {
        this._reels[reelIndex].fadeSymbol(rowIndex);
    }

    public get dimensions(): number[] {
        return this._dimensions;
    }

    public set dimensions(value: number[]) {
        this._dimensions = value;
    }

    public resetSymbols(): void {
        this._reels.forEach((reel) => reel.resetSymbols());
    }

    public onWildLanded(reelIndex: number, rowIndex: number): void {
        this._reels[reelIndex].setWildSymbol(rowIndex);
        this.putOversizedsOnSpecialLayer(reelIndex);
        this.reOrder();
    }

    public get soundManager(): SoundManager {
        return this._soundManager;
    }

    public static layer: Layer = LAYERS.REELS;
}
